<template>
  <div v-if="data && data.phone" class="d-flex align-center">
    <v-chip :href="`https://www.google.com/search?q=0${data.phone.slice(-10)}`" class="rounded-lg" small
            target="_blank">
      {{ data.phone }}
    </v-chip>

    <v-btn class="ms-1" icon small @click="copyLink(data.phone, false)">
      <v-icon small>mdi-content-copy</v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  name: "userPhoneButtons",

  props: {
    data: Object
  }
}
</script>

<style scoped>

</style>